(function () {
  'use strict';

  if (window.CiranovaSystemEngine) return;

  var VERSION = 'application-chart-2026-07';
  var STATUS = {
    '▲': 'recommended',
    '•': 'possible',
    '▼': 'not_recommended',
    'NA': 'not_applicable'
  };
  var WOODS = [
    { value: 'WHITE_OAK', label: 'White Oak' },
    { value: 'RED_OAK', label: 'Red Oak' },
    { value: 'ASH', label: 'Ash' },
    { value: 'MAPLE_BIRCH', label: 'Maple / Birch' },
    { value: 'PINE', label: 'Pine' },
    { value: 'HICKORY', label: 'Hickory' },
    { value: 'WALNUT', label: 'Walnut' }
  ];
  var LOOKS = [
    { value: 'NATURAL', label: 'Natural look' },
    { value: 'SUBTLE_AGED', label: 'Subtle aged look' },
    { value: 'VINTAGE', label: 'Vintage look' },
    { value: 'FULL_COLOR_STAINED', label: 'Full color stained' },
    { value: 'FULL_COLOR_OILED', label: 'Full color oiled' }
  ];
  var PROTECT_GROUP = {
    UN1CO: 'OILS',
    MAGIC: 'OILS',
    TITAN: 'OILS',
    OCULTO: 'WATERBORNE',
    ECOFIX: 'WATERBORNE',
    WOODLOOK: 'WATERBORNE',
    EASY_FLOW: 'WATERBORNE',
    FORTICO_2C: 'WATERBORNE'
  };
  var PROTECT_LABEL = {
    UN1CO: 'UN1CO',
    MAGIC: 'Magic',
    TITAN: 'Titan',
    OCULTO: 'Oculto',
    ECOFIX: 'Ecofix',
    WOODLOOK: 'Woodlook',
    EASY_FLOW: 'Easy Flow',
    FORTICO_2C: 'Fortico 2C'
  };
  var PRODUCT_HANDLES = {
    colors: {
      PINK_BLOCKER: 'pink-blocker',
      REACTIVE_STAIN: 'reactive-stain',
      AQUAVINTAGE_2C: 'kit-aquavintage-2c',
      VINTAGE: 'vintage',
      AQUASTAIN: 'aquastain'
    },
    protection: {
      UN1CO: 'hardwaxoil-unico',
      MAGIC: 'hardwaxoil-magic-5l',
      TITAN: 'hardwaxoil-titan',
      OCULTO: 'oculto-plus',
      ECOFIX: 'ecofix-plus',
      WOODLOOK: 'woodlook-plus',
      EASY_FLOW: 'easy-flow',
      FORTICO_2C: 'fortico-2c'
    },
    maintenance: {
      OILS: ['flooring-soap', 'maintenance-oil', 'kit-oiled-floors-white'],
      WATERBORNE: ['hard-floor-cleaner', 'kit-varnished-floors-matt']
    }
  };

  var MATRIX = {
    WHITE_OAK: {
      NATURAL: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '▲', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '▲', colorWith: 'Vintage X or F', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '▼', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    },
    RED_OAK: {
      NATURAL: { colorRec: '▲', colorWith: 'Option Pink Blocker', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '▲', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '•', colorWith: 'Vintage X or F', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    },
    ASH: {
      NATURAL: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '•', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '▼', colorWith: 'Vintage X or F', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '▼', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    },
    MAPLE_BIRCH: {
      NATURAL: { colorRec: '▲', colorWith: 'Option Pink Blocker', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '•', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '▼', colorWith: 'Vintage X or F', protect: { UN1CO: '▼', MAGIC: '▼', TITAN: '▼', OCULTO: '▼', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    },
    PINE: {
      NATURAL: { colorRec: '▲', colorWith: 'Option Pink Blocker', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '•', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '•', colorWith: 'Vintage X or F', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '▼', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    },
    HICKORY: {
      NATURAL: { colorRec: '▲', colorWith: 'Option Pink Blocker', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '•', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '•', colorWith: 'Vintage X or F', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '▼', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    },
    WALNUT: {
      NATURAL: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '•', MAGIC: '▼', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      SUBTLE_AGED: { colorRec: '▲', colorWith: 'RS / AQV 2C', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '•', ECOFIX: '▲', WOODLOOK: '•', EASY_FLOW: '•', FORTICO_2C: '•' } },
      VINTAGE: { colorRec: '▲', colorWith: 'Vintage X or F', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '•', OCULTO: '▼', ECOFIX: '▼', WOODLOOK: '▼', EASY_FLOW: '▼', FORTICO_2C: '▼' } },
      FULL_COLOR_STAINED: { colorRec: '▲', colorWith: 'Aquastain', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▲', OCULTO: '▲', ECOFIX: '▲', WOODLOOK: '▲', EASY_FLOW: '▲', FORTICO_2C: '▲' } },
      FULL_COLOR_OILED: { colorRec: '▲', colorWith: '/', protect: { UN1CO: '▲', MAGIC: '▲', TITAN: '▼', OCULTO: 'NA', ECOFIX: 'NA', WOODLOOK: 'NA', EASY_FLOW: 'NA', FORTICO_2C: 'NA' } }
    }
  };

  function colorOptions(colorWith) {
    if (colorWith === '/') return [];
    if (colorWith === 'Option Pink Blocker') {
      return [{ key: 'PINK_BLOCKER', handle: PRODUCT_HANDLES.colors.PINK_BLOCKER, optional: true }];
    }
    if (colorWith === 'RS / AQV 2C') {
      return [
        { key: 'REACTIVE_STAIN', handle: PRODUCT_HANDLES.colors.REACTIVE_STAIN },
        { key: 'AQUAVINTAGE_2C', handle: PRODUCT_HANDLES.colors.AQUAVINTAGE_2C }
      ];
    }
    if (colorWith === 'Vintage X or F') {
      return [{
        key: 'VINTAGE',
        handle: PRODUCT_HANDLES.colors.VINTAGE,
        allowedOptions: ['X 8090', 'F 6777']
      }];
    }
    if (colorWith === 'Aquastain') {
      return [{ key: 'AQUASTAIN', handle: PRODUCT_HANDLES.colors.AQUASTAIN }];
    }
    return [];
  }

  function recommend(input) {
    var wood = String((input && input.wood) || '');
    var look = String((input && input.look) || '');
    var finishFamily = String((input && input.finishFamily) || 'all').toLowerCase();
    var rule = MATRIX[wood] && MATRIX[wood][look];
    if (!rule) return null;

    var protections = Object.keys(PROTECT_LABEL).map(function (key) {
      var symbol = rule.protect[key] || '•';
      var group = PROTECT_GROUP[key];
      return {
        key: key,
        label: PROTECT_LABEL[key],
        handle: PRODUCT_HANDLES.protection[key],
        group: group,
        symbol: symbol,
        status: STATUS[symbol] || 'possible',
        selectable: symbol === '▲' || symbol === '•'
      };
    }).filter(function (item) {
      if (finishFamily === 'oils') return item.group === 'OILS';
      if (finishFamily === 'waterborne') return item.group === 'WATERBORNE';
      return true;
    }).sort(function (a, b) {
      var order = { recommended: 0, possible: 1, not_recommended: 2, not_applicable: 3 };
      return order[a.status] - order[b.status];
    });

    return {
      version: VERSION,
      wood: wood,
      look: look,
      finishFamily: finishFamily,
      colorText: rule.colorWith,
      colorStatus: STATUS[rule.colorRec] || 'possible',
      colors: colorOptions(rule.colorWith),
      protections: protections
    };
  }

  window.CiranovaSystemEngine = {
    version: VERSION,
    woods: WOODS,
    looks: LOOKS,
    rules: MATRIX,
    status: STATUS,
    protectGroups: PROTECT_GROUP,
    protectLabels: PROTECT_LABEL,
    productHandles: PRODUCT_HANDLES,
    colorOptions: colorOptions,
    recommend: recommend
  };
  if (typeof window.dispatchEvent === 'function' && typeof CustomEvent === 'function') {
    window.dispatchEvent(new CustomEvent('ciranova:system-engine-ready'));
  }
})();
